export const types = {
  SET_EDITABLE_SUBNET_INFO: 'SET_EDITABLE_SUBNET_INFO',
  SET_VALIDATION_SUBNET_INFO: 'SET_VALIDATION_SUBNET_INFO',
  RESET_SUBNET_EDIT_FORM_DATA: 'RESET_SUBNET_EDIT_FORM_DATA',
  UPDATE_SUBNET_INFO: 'UPDATE_SUBNET_INFO',
};

export function setEditableSubnetInfo(subnet) {
  return (dispatch) => {
    dispatch({
      type: types.SET_EDITABLE_SUBNET_INFO,
      data: subnet,
    });
  };
}

export function updateSubnetInfo(updatedSubnetInfo, isValid) {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_SUBNET_INFO,
      data: updatedSubnetInfo,
      isValidSubnetInfo: isValid,
    });
  };
}

export function resetSubnetEditFormData() {
  return (dispatch) => {
    dispatch({
      type: types.RESET_SUBNET_EDIT_FORM_DATA,
    });
  };
}

export function setValidationSubnetInfo(isValid) {
  return (dispatch) => {
    dispatch({
      type: types.SET_VALIDATION_SUBNET_INFO,
      isValid,
    });
  };
}
